import { Navigate, useParams, useSearchParams } from 'router-v6'

// Redirect that carries the URL params and the query string over to the new path.
export const ParamRedirect = ({
  to,
}: {
  to: (p: Record<string, string | undefined>) => string
}) => {
  const params = useParams()
  const [searchParams] = useSearchParams()
  const search = searchParams.toString()
  return <Navigate to={`${to(params)}${search ? `?${search}` : ''}`} replace />
}
